import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar-wrapper" }
const _hoisted_2 = { class: "sb-nav" }
const _hoisted_3 = ["onClick", "title"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "sb-btn-icon"
}
const _hoisted_6 = { class: "sb-btn-label" }
const _hoisted_7 = ["onClick", "title"]
const _hoisted_8 = { class: "sb-btn-label" }
const _hoisted_9 = { class: "sb-bottom" }
const _hoisted_10 = ["onClick", "title"]
const _hoisted_11 = { class: "sb-btn-icon" }
const _hoisted_12 = { class: "sb-btn-label" }
const _hoisted_13 = { class: "sb-btn-icon" }
const _hoisted_14 = { class: "sb-btn-label" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  class: "mobile-nav",
  "aria-label": "Bottom navigation"
}
const _hoisted_17 = ["aria-current", "onClick"]
const _hoisted_18 = { class: "mobile-nav-icon-shell" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "sb-btn-icon"
}
const _hoisted_21 = { class: "mobile-nav-label" }
const _hoisted_22 = ["aria-expanded"]
const _hoisted_23 = {
  class: "more-sheet",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "more-sheet-title"
}
const _hoisted_24 = { class: "more-sheet__section-title" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "more-sheet__product-icon" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "sb-btn-icon"
}
const _hoisted_29 = {
  key: 2,
  class: "sb-btn-icon sb-btn-icon--sub"
}
const _hoisted_30 = { class: "more-sheet__product-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "sidebarRef",
      class: _normalizeClass(["floating-sidebar", { expanded: $setup.isExpanded }])
    }, [
      _createCommentVNode(" Logo "),
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"sb-logo\" data-v-62217b2c><svg width=\"31\" height=\"32\" viewBox=\"0 0 31 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-62217b2c><g clip-path=\"url(#clip0_1_2775)\" data-v-62217b2c><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 0C6.93959 0 0 6.92466 0 15.4667V16.5333C0 25.0753 6.93959 32 15.5 32C24.0604 32 31 25.0753 31 16.5333V15.4667C31 6.92466 24.0604 0 15.5 0ZM17.8138 24.9838C21.5788 24.2433 23.8443 19.6605 22.874 14.7475C21.9036 9.83468 18.0649 6.45224 14.2999 7.19266C10.5349 7.9331 8.26938 12.5161 9.23972 17.4289C10.2101 22.3418 14.0488 25.7242 17.8138 24.9838Z\" fill=\"currentColor\" data-v-62217b2c></path></g><defs data-v-62217b2c><clipPath id=\"clip0_1_2775\" data-v-62217b2c><rect width=\"31\" height=\"32\" fill=\"white\" data-v-62217b2c></rect></clipPath></defs></svg></div>", 1)),
      _createCommentVNode(" Main Navigation "),
      _createElementVNode("nav", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.computedNavItems, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.name
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["sb-btn", { active: $setup.isActive(item.route) }]),
              onClick: ($event: any) => ($setup.navigateTo(item.route)),
              title: item.label
            }, [
              (item.svg)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "sb-btn-icon",
                    innerHTML: item.svg
                  }, null, 8 /* PROPS */, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      size: 24,
                      weight: "regular"
                    }))
                  ])),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_3),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.children || []), (child) => {
              return (_openBlock(), _createElementBlock("button", {
                key: child.name,
                class: _normalizeClass(["sb-btn sb-btn--sub", { active: $setup.isActive(child.route) }]),
                onClick: ($event: any) => ($setup.navigateTo(child.route)),
                title: child.label
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sb-btn-icon sb-btn-icon--sub" }, [
                  _createElementVNode("span", { class: "sb-sub-dot" })
                ], -1 /* CACHED */)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(child.label), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createCommentVNode(" Bottom Section "),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.computedFooterItems, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.name,
            class: _normalizeClass(["sb-btn", { active: $setup.isActive(item.route) }]),
            onClick: ($event: any) => ($setup.navigateTo(item.route)),
            title: item.label
          }, [
            _createElementVNode("span", _hoisted_11, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                size: 24,
                weight: "regular"
              }))
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_10))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" Toggle expand/collapse "),
        _createElementVNode("button", {
          class: "sb-btn sb-toggle",
          onClick: $setup.toggleSidebar,
          title: "Expand menu"
        }, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode($setup["PhCaretRight"], {
              size: 24,
              weight: "regular",
              class: _normalizeClass({ 'sb-toggle-rotated': $setup.isExpanded })
            }, null, 8 /* PROPS */, ["class"])
          ]),
          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.t('nav.collapse')), 1 /* TEXT */)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sb-divider" }, null, -1 /* CACHED */)),
        _createElementVNode("div", {
          class: "sb-avatar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.navigateTo('/app/settings'))),
          title: "Settings"
        }, [
          _createElementVNode("img", {
            src: $props.userAvatar || $setup.profileAvatarSvg,
            alt: "Profile"
          }, null, 8 /* PROPS */, _hoisted_15)
        ])
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" Mobile Bottom Navigation "),
    _createElementVNode("nav", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mobileBottomItems, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.activeKey,
          type: "button",
          class: _normalizeClass(["mobile-nav-item", { active: $setup.isMobileNavActive(item.activeKey) }]),
          "aria-current": $setup.isMobileNavActive(item.activeKey) ? 'page' : undefined,
          onClick: ($event: any) => ($setup.navigateTo(item.route))
        }, [
          _createElementVNode("span", _hoisted_18, [
            (item.svg)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "sb-btn-icon",
                  innerHTML: item.svg
                }, null, 8 /* PROPS */, _hoisted_19))
              : (item.icon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      size: 28,
                      weight: "regular"
                    }))
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString(item.label), 1 /* TEXT */)
        ], 10 /* CLASS, PROPS */, _hoisted_17))
      }), 128 /* KEYED_FRAGMENT */)),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["mobile-nav-item", { active: $setup.moreSheetOpen }]),
        "aria-expanded": $setup.moreSheetOpen,
        onClick: $setup.toggleMoreSheet
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("svg", {
          class: "mobile-nav-icon",
          viewBox: "0 0 28 28",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M7 17.5L14 10.5L21 17.5",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1 /* CACHED */),
        _createElementVNode("span", { class: "mobile-nav-label" }, "More", -1 /* CACHED */)
      ]), 10 /* CLASS, PROPS */, _hoisted_22)
    ]),
    _createCommentVNode(" More Bottom Sheet "),
    _createVNode(_Transition, { name: "more-sheet" }, {
      default: _withCtx(() => [
        ($setup.moreSheetOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "more-sheet-overlay",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.moreSheetOpen = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "more-sheet__handle-row" }, [
                  _createElementVNode("div", { class: "more-sheet__handle" })
                ], -1 /* CACHED */)),
                _cache[8] || (_cache[8] = _createElementVNode("h2", {
                  id: "more-sheet-title",
                  class: "more-sheet__title"
                }, "Nebeus products", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mobileProductSections, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.label,
                    class: "more-sheet__section"
                  }, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(section.label), 1 /* TEXT */),
                    _createElementVNode("div", {
                      class: _normalizeClass(["more-sheet__product-grid", { 'more-sheet__product-grid--single': section.items.length === 1 }]),
                      style: _normalizeStyle({ '--product-count': section.items.length })
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: item.name,
                          class: "more-sheet__product",
                          type: "button",
                          onClick: ($event: any) => ($setup.moreNavigate(item.route))
                        }, [
                          _createElementVNode("span", _hoisted_26, [
                            (item.svg)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "sb-btn-icon",
                                  innerHTML: item.svg
                                }, null, 8 /* PROPS */, _hoisted_27))
                              : (item.icon)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                      size: 24,
                                      weight: "regular"
                                    }))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("span", { class: "sb-sub-dot" }, null, -1 /* CACHED */)
                                  ]))]))
                          ]),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(item.label), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_25))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 6 /* CLASS, STYLE */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}